import Link from "next/link";
import classNames from "classnames/bind";
import styles from "./Button.module.css";
/**
 * Figma system doesn't have a nice system of all the possible variants and sizes,
 * so using `shape` handle those one-off use-cases with differing styles.
 */
export interface ButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  href?: string;
  type?: "button" | "submit";
  variant?: "primary" | "secondary-dark" | "secondary-light";
  children: React.ReactNode;
  ariaLabel?: string;
  isExternal?: boolean;
  decorative?: boolean;
  className?: string;
  shape?: "default" | "play" | "carousel" /* 1 */;
}

const cx = classNames.bind(styles);

export function Button({
  onClick,
  disabled = false,
  href,
  type = "button",
  variant = "primary",
  shape,
  ariaLabel,
  children,
  isExternal = false,
  decorative,
  className,
}: ButtonProps) {
  const baseProps = {
    "data-variant": variant,
    "data-shape": shape,
    className: cx("button", className),
  };

  if (decorative) {
    <div {...baseProps}>{children}</div>;
  }

  if (href && isExternal) {
    return (
      <a {...baseProps} href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  } else if (href) {
    return (
      <Link {...baseProps} href={href}>
        {children}
      </Link>
    );
  }

  return (
    <button
      {...baseProps}
      type={type}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}
